// Add security profile main router component.
// this Route consists of 3 other nested routes under "/addProfile" defined below
import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route, NavLink } from "react-router-dom";
import BasicSettings from "../../../../../Dashboard/Components/SecuritySettings/ACLs/EditACL/BasicSettings";
import Mapping from "../../../../../Dashboard/Components/SecuritySettings/ACLs/EditACL/Mapping";
import Advanced from "../../../../../Dashboard/Components/SecuritySettings/ACLs/EditACL/Advanced";
import DesktopOnlyOverlay from "../../../../../Dashboard/Components/ShareElements/DesktopOnlyOverlay/DesktopOnlyOverlay";
import ContentHeader from "../../../../../Dashboard/Components/ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../../../Assets/Images/sm-Circle.svg";
import UnsavedChangesAlert from "../../../../../Dashboard/Components/ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";

const EditACL = (props) => {
  const [UnsavedChanges, setUnsavedChanges] = useState(false);
  const [NavIdClicked, setNavId] = useState("");
  useEffect(() => {
    window.localStorage.setItem("HasUnsaveChanges", 0);
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const validateNavigation = (e, Id) => {
    window.localStorage.setItem("LastIdClicked", Id); // for save and leave or discard and leave buttons
    let UnsavedChangesStatus = parseInt(
      window.localStorage.getItem("HasUnsaveChanges")
    ); //true: 1, false: 0
    if (UnsavedChangesStatus === 0) {
      document.getElementById(Id).click();
      transformIndicator(Id); // gets the id and translates the indicator on the navigator
    } else if (UnsavedChangesStatus === 1) {
      e.preventDefault();
      setUnsavedChanges(true);
      setNavId(Id);
    }
  };
  const close = () => {
    setUnsavedChanges(false);
    console.log("close");
  };
  const discard = () => {
    setUnsavedChanges(false);
    window.localStorage.setItem("HasUnsaveChanges", 0);
    document.getElementById(NavIdClicked).click();
  };
  const saveAndLeave = () => {
    setUnsavedChanges(false);
    window.localStorage.setItem("HasUnsaveChanges", 0);
    document.getElementById("save-btn").click();
    setTimeout(() => {
      if (
        document.getElementById("bu-error") !== null &&
        document.getElementById("reg-error") !== null &&
        document.getElementById("country-error") !== null &&
        document.getElementById("dept-error") !== null
      ) {
        if (
          document.getElementById("bu-error").style.display !== "block" ||
          document.getElementById("reg-error").style.display !== "block" ||
          document.getElementById("country-error").style.display !== "block" ||
          document.getElementById("dept-error").style.display !== "block"
        ) {
          document
            .getElementById(window.localStorage.getItem("LastIdClicked"))
            .click();
        }
      }
      if (
        document.getElementById("name-label-holder") !== null &&
        document.getElementById("name-label-holder").classList.length < 2
      ) {
        document
          .getElementById(window.localStorage.getItem("LastIdClicked"))
          .click();
      }
    }, 1500);
  };
  const transformIndicator = (Id) => {
    if (Id === "mapping") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(134px)";
    } else if (Id === "basic-settings") {
      document.getElementById("animated-indicator").style.transform = "none";
    } else {
      document.getElementById("animated-indicator").style.transform =
        "translateX(269px)";
    }
  };
  return (
    <BrowserRouter basename="/home/acls/editACL">
      {UnsavedChanges ? (
        <UnsavedChangesAlert
          close={() => close()}
          saveAndLeave={() => saveAndLeave()}
          discardAndLeave={() => discard()}
          AlertMessage={translateText("unsaved_changes_tab_switch_warning")}
          CancelText={translateText("cancel")}
          SaveText={translateText("save_changes")}
          LangData={props.LangData}
        />
      ) : null}
      <DesktopOnlyOverlay LangData={props.LangData} />
      <div className="main-content security-settings security-profiles">
        <ContentHeader PageName={translateText("access_control_lists")} />
        <div className="content-header">
          <div className="address">
            <p>{translateText("security_settings")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("acls")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("add_acl")}</p>
          </div>
        </div>
        <div className="actions navigator navigator-sm">
          <span id="animated-indicator"></span>
          <NavLink
            onClick={(e) => validateNavigation(e, "basic-settings")}
            activeClassName="active-nav-node"
            exact
            id="basic-settings"
            to="/"
          >
            <p>{translateText("basic_settings")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "mapping")}
            activeClassName="active-nav-node"
            to="/mapping"
            id="mapping"
          >
            <p>{translateText("mapping")}</p>
          </NavLink>
          {/* <NavLink
            onClick={(e) => validateNavigation(e, "advanced")}
            activeClassName="active-nav-node"
            id="advanced"
            to="/advanced"
          >
            <p>Advanced</p>
          </NavLink> */}
        </div>
        <Switch>
          <Route path="/mapping" exact>
            <Mapping LangData={props.LangData} />
          </Route>
          <Route path="/advanced" exact>
            <Advanced />
          </Route>
          <Route path="/" exact>
            <BasicSettings LangData={props.LangData} />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
};

export default EditACL;
